// @flow

// Grab from env vars if they are set
const {
  NODE_ENV,

  API_URL,
  ROOT_URL,

  ROLLBAR_ENV,
  ROLLBAR_TOKEN,
} = process.env;

// Set defaults
const env = {
  // Since NODE_ENV is automatically used by many plugins, we can't ensure it
  // will produce dev/prod parity by itself. Consequently, we need to use
  // separate ENVs for apps.
  NODE_ENV: NODE_ENV || "production",

  // App settings
  API_URL: API_URL || "https://baconipsum.com/api",
  ROOT_URL: ROOT_URL || "http://localhost:3000",

  // Rollbar.io
  ROLLBAR_ENV: ROLLBAR_ENV || "development",
  ROLLBAR_TOKEN: ROLLBAR_TOKEN || "7fa40d552a364292a913cc64d66311c6",
};

export const isBrowser = (): boolean =>
  Boolean(typeof window !== "undefined" && window.document);

const getEnv = () => {
  if (NODE_ENV === "test") return env;

  // When using server rendering, we can pass the env state via a window
  // property to prevent bundling the env values in the build. This allows us
  // to change the values in the server runtime and have them immediately
  // reflected in the next browser refresh. Since we're not using server
  // rendering in this project, it's disabled.
  // if (isBrowser()) return window[envStateVar].env;

  return env;
};

const dynamicEnv = getEnv();

export default dynamicEnv;



// WEBPACK FOOTER //
// ./src/etc/env.js